import { Chapter } from "@/components/Chapter";
import { Reveal } from "@/components/Reveal";

const ASSURANCES = [
    "Materials perform as intended",
    "Structures function as required",
    "Spaces endure over time",
];

const VALUES = [
    {
        title: "Design Without Budget Bias",
        text: "A dream is not defined by budget. We approach every project with the same intent—adapting materials and scale, but never compromising on thought.",
    },
    {
        title: "Value Over Vanity",
        text: "We don’t design for photographs. We design for daily comfort, durability, and long-term satisfaction—because true luxury reveals itself over time.",
    },
];

export const Engineering = () => (
    <Chapter number="06" label="Engineering Advantage" title="Precision Behind Every Detail" testid="manifesto-chapter-08" dark>
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-2 lg:gap-16">
            <Reveal delay={0.15} className="space-y-6 text-base font-light leading-relaxed text-ivory/70 sm:text-lg">
                <p>
                    Design without engineering is incomplete. Because what is unseen is just as
                    important as what is visible.
                </p>
                <ul className="divide-y divide-ivory/10 border-y border-ivory/10">
                    {ASSURANCES.map((a, i) => (
                        <li key={a} className="flex items-baseline gap-4 py-4">
                            <span className="font-mono text-xs text-gold">0{i + 1}</span>
                            <span className="text-base text-ivory">{a}</span>
                        </li>
                    ))}
                </ul>
            </Reveal>
            <div className="space-y-6">
                {VALUES.map((v, i) => (
                    <Reveal key={v.title} delay={0.1 * i + 0.2}>
                        <div className="border border-ivory/10 p-8 transition-colors duration-500 hover:border-gold/40">
                            <h3 className="font-serif text-xl font-medium text-ivory sm:text-2xl">{v.title}</h3>
                            <p className="mt-3 text-sm font-light leading-relaxed text-ivory/60">{v.text}</p>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </Chapter>
);
